import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemsSection } from './components/ProblemsSection';
import { FeaturesSection } from './components/FeaturesSection';
import { PricingSection } from './components/PricingSection';
import { TrustSection } from './components/TrustSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0f] text-white selection:bg-[#00ff88] selection:text-[#0a0a0f]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemsSection data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <TrustSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}